export default __webpack_public_path__ + "assets/ico_close-f87a9f84.svg";